<template>
    <div>
        <h3>Download PM Report</h3>
        <div class="row">
            <div class="col-md-2">
                <p>Select the type of report you want to download:</p>
                <div class="card">
                    <el-select v-model="reportType">
                        <el-option value="area" label="Area">Area</el-option>
                        <el-option value="city" label="City/District/Village">City/District/Village</el-option>
                        <el-option value="sterilization" label="Sterilization Data">Sterilization Data</el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <pm-area-report v-if="reportType === 'area'" />
                <pm-report-by-city v-if="reportType === 'city'" />
                <full-program-data v-if="reportType === 'sterilization'" />
            </div>
        </div>
    </div>
</template>
<script>
import { Card, Select } from 'element-ui';
import PmAreaReport from './PmAreaReport.vue';
import PmReportByCity from './PmReportByCity.vue';
import FullProgramData from '../FullProgramData.vue';

export default {
    components: {
        PmAreaReport,
        PmReportByCity,
        FullProgramData,
        [Card.name]: Card,
        [Select.name]: Select
    },
    data () {
        return {
            reportType: 'area'
        }
    }
};
</script>